










import {
  Component, Vue, Prop, Watch,
} from 'vue-property-decorator';

@Component
export default class PageLoading extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  })
  status!: boolean;

  localStatus = this.status;

  @Watch('status')
  onPropStatusChanged() {
    this.localStatus = this.status;
  }

  show() {
    this.localStatus = true;
  }

  hide() {
    this.localStatus = false;
  }
}
